import { gql } from '@apollo/client';
const APPROVE_ORDER_SPECIFICATION_PRODUCTION = gql `
  mutation ApproveOrderSpecificationProduction($orderId: ID!, $specificationId: ID!) {
    approveOrderSpecificationProduction(orderId: $orderId, specificationId: $specificationId) {
      specification {
        id
      }
      productionApproved
      productionStartDate
      virtualProductionEndDate
      sumOfModelQuantities
      totalProductionTimeMinutes
      priority
      manufacturer {
        id
        shortName
        fullName
        employeesCount
        picture
        nonWorkingDays {
          id
          startDate
          endDate
        }
      }
      modelsCount
      suppliersCount
      manufacturerOccupiedDates
    }
  }
`;
export default APPROVE_ORDER_SPECIFICATION_PRODUCTION;
